import React, { Component } from 'react';
import { Button, Modal, Dropdown } from 'semantic-ui-react'

class PlansListModal extends Component {
  constructor(props){
    super(props);
    this.state = {
      value: 1
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      value: nextProps.options.length === 0 ? 1 : nextProps.options[nextProps.options.length-1].value
    })
  }

  handleCallback(evt){
    this.props.callback(this.state.value)
    this.props.onClose();
  }

  handleChange(evt, object){
    this.setState({
      value: object.value
    })
  }

  render() {

    const { trigger, options, type, shown, onClose, pending } = this.props;
    var headerText = "Select a " + type;
    var buttonText = type === "Plan" ? "View Plan" : "Create Plan";
    return (
      <Modal trigger={trigger} size="tiny" open={shown} onClose={onClose}>
        <Modal.Header>{headerText}</Modal.Header>
        <Modal.Content>
          <Dropdown placeholder={this.headerText} search selection options={options} onChange={this.handleChange.bind(this)} defaultValue={this.state.value}/>
        </Modal.Content>
        <Modal.Actions><Button color='teal' fluid size='medium' loading={pending} onClick={(evt) => this.handleCallback(evt)} className="new-plan-button">{buttonText}</Button></Modal.Actions>
        <i className="delete icon" onClick={onClose}></i>
      </Modal>
    )
  }
}

export default PlansListModal



// WEBPACK FOOTER //
// ./src/components/custom_modal.js